import { Divider } from '@snack-uikit/divider';
import { Typography } from '@snack-uikit/typography';
import { useState } from 'react';

import { Feedback, FooterNav, FooterNavProps } from '@/components/static';
import { CopyRights } from '@/components/static/Footer/CopyRights';
import s from '@/components/static/Footer/styles.module.scss';

import { useSendFeedback } from './utils';

export function ArticleFooter({ prev, next }: Partial<FooterNavProps>) {
  const [isOpenThanksBlock, setIsOpenThanksBlock] = useState(false);
  const [isOpenFeedbackForm, setIsOpenFeedbackForm] = useState(false);

  const { isLoading, sendFeedback, sendFeedbackWithComment } = useSendFeedback(
    setIsOpenThanksBlock,
    setIsOpenFeedbackForm,
  );

  return (
    <div className={s.footer_wrapper}>
      <Feedback
        isOpenFeedbackForm={isOpenFeedbackForm}
        setIsOpenFeedbackForm={setIsOpenFeedbackForm}
        setIsOpenThanksBlock={setIsOpenThanksBlock}
        isOpenThanksBlock={isOpenThanksBlock}
        onSubmitForm={sendFeedbackWithComment}
        onChooseScore={sendFeedback}
        isLoadingSendFeedback={isLoading}
      >
        <Typography.SansTitleM>Была ли статья полезной ?</Typography.SansTitleM>
      </Feedback>
      <Divider />
      <FooterNav next={next} prev={prev} />
      <CopyRights />
    </div>
  );
}
